import 'regenerator-runtime/runtime';
import { call, cancel, put, select, takeEvery } from 'redux-saga/effects';
import { AnyAction } from 'redux';
import {
  AngebotsId,
  ANTRAGSNUMMER_EVENTS,
  DoRequestResponse,
  GlobalAction,
  GlobalActions,
  GlobalPut,
} from '@ps20-frontend/shop-integration-redux';
import { App } from '@ps20-frontend/frontend-models';
import { PS20Logger } from '@ps20-frontend/logging';
import { safeSaga } from '@ps20-frontend/safe-saga';
import { TkvActions } from '../tkvActions';
import { IAppState } from '../appState';

/** The offer is taken over into the dashboard with the Tiergruppe, but is not the last one. */
const isDeferred = (successAction: DoRequestResponse<string>): boolean =>
  (successAction.doRequestAction.payload.additionalData as { deferTarifierung?: boolean })
    ?.deferTarifierung === true;

export function* watchAntragsnummerRequested() {
  yield takeEvery(
    GlobalActions.ANTRAGSNUMMER_REQUESTED,
    safeSaga(antragsnummerSagaForAntragsNummerRequested, App.TKV_V2),
  );
  yield takeEvery(
    TkvActions.VORSCHLAGDATEN_CHANGED,
    safeSaga(antragsnummerSagaForVorschlagDatenChanged, App.TKV_V2),
  );
  yield takeEvery(
    ANTRAGSNUMMER_EVENTS.ANTRAGSNUMMER_SUCCESSFULL,
    safeSaga(successCallback, App.TKV_V2),
  );
}

export function* antragsnummerSagaForAntragsNummerRequested(action: GlobalAction<AngebotsId>) {
  const store: IAppState = yield select();
  const angebotsIdInStore = store.angebotsId;
  const { appId, angebotsId } = action.payload;

  if (appId === App.TKV_V2 && angebotsId === angebotsIdInStore) {
    yield* doRequestAntragsnummer(angebotsId);
  }
}

export function* antragsnummerSagaForVorschlagDatenChanged(action?: AnyAction) {
  const store: IAppState = yield select();
  const angebotsIdInStore = store.angebotsId;

  yield* doRequestAntragsnummer(angebotsIdInStore, action?.payload);
}

export function* successCallback(successAction: DoRequestResponse<string>) {
  try {
    const { appId, angebotsId } = successAction.doRequestAction.payload;
    const store: IAppState = yield select();
    const angebotsIdInStore = store.angebotsId;
    if (appId === App.TKV_V2 && angebotsId === angebotsIdInStore) {
      const globalPut = GlobalPut.getInstance();
      const antragsnummerAsString = successAction.payload.toString();
      yield put(new TkvActions().antragsnummerGenerated(antragsnummerAsString));
      yield call(
        [globalPut, globalPut.put],
        new GlobalActions().antragsnummerGenerated(
          isDeferred(successAction),
        ),
      );
    }
  } catch (exception) {
    PS20Logger.error(
      App.TKV_V2,
      exception as Error,
      'antragsnummerSaga successCallback Antragsnummer konnte nicht verarbeitet werden',
    );
    yield cancel();
  }
}

function* doRequestAntragsnummer(angebotsId: string, additionalData?: unknown) {
  const globalPut = GlobalPut.getInstance();

  yield call(
    globalPut.put.bind(globalPut),
    new GlobalActions().doRequestAntragsnummer(
      App.TKV_V2,
      ANTRAGSNUMMER_EVENTS.ANTRAGSNUMMER_SUCCESSFULL,
      ANTRAGSNUMMER_EVENTS.ANTRAGSNUMMER_FAILED,
      angebotsId,
      additionalData,
    ),
  );
}
